import _ from "lodash";

export const getPCPointFields = (label, data, listClusters, fields,
    isVisitor) => {
    const array = [];
    let baseUrl = "";
    if (typeof window !== "undefined") {
        baseUrl = `${window.location.protocol}//${window.location.host}/dashboard/management/monitoring-points-list`;
    }
    listClusters?.map((item) => {
        return array.push({
            version: "v1",
            info: {
                label: `${label}-${item}`,
                id: `${label}-${item}`,
            },
            data: {
                id: `${label}-${item}`,
                label: `${label}-${item}`,
                rows: [],
                fields: fields,
            },
        });
    });

    if (data && !_.isEmpty(array)) {
        data?.map((item) => {
            const index = _.findIndex(listClusters, function (o) {
                return o === item?.cluster;
            });
            return (
                item?.peopleCounter &&
                array[index].data?.rows.push([
                    item?.stationId,
                    item?.address,
                    item?.cluster,
                    item?.coordinates.lat,
                    item?.coordinates.long,
                    isVisitor ? '' : `${baseUrl}/${item?.stationId}`,
                ])
            );
        });
    }

    return array;
};
